import { CcRequirementState } from "server/models"
import { GET, POST } from "client/store/utils"

export const LoadCcRequirementState = (requirementId: number, revisionId: number) => (
    GET(`/ccRequirementState/requirement/${requirementId}/revision/${revisionId}`)
    .then((state: CcRequirementState) => state)
)
export const UpdateCcRequirementVerifier = (data: CcRequirementState[]) => (
    POST(
        "/ccRequirementState/verifier",
        JSON.stringify(data),
    )
)
export const UpdateCcRequirementState = (data: CcRequirementState) => (
    POST(
        "/ccRequirementState/update",
        JSON.stringify(data),
    )
)
export const CreateCcRequirementState = (data: CcRequirementState) => (
    POST(
        "/ccRequirementState/create",
        JSON.stringify(data),
    )
)
